module.exports = __webpack_public_path__ + "pnskfsquadron/img/book-hero9.png?a3335816";